/* eslint-disable react/jsx-newline */
import { Language } from "../../config/LanguageConfiguration";
import {
  TranslatableText,
  TranslatableTextAndReactElement,
} from "../interfaces/TranslatableText";
import theme from "../layouts/theme";

export interface PrivacyPolicyProps {
  title: TranslatableText;
  text: TranslatableTextAndReactElement;
}

export const privacyPolicy: PrivacyPolicyProps = {
  title: {
    [Language.German]: "Datenschutz­erklärung",
    [Language.English]: "Privacy policy",
  },
  text: {
    [Language.German]: (
      <>
        <h2>1. Datenschutz auf einen Blick</h2>

        <strong>Allgemeine Hinweise</strong>

        <p>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was
          mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
          besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
          persönlich identifiziert werden können. Ausführliche Informationen zum
          Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten
          Datenschutzerklärung.
        </p>

        <strong>Datenerfassung auf dieser Website</strong>

        <p>
          WER IST VERANTWORTLICH FÜR DIE DATENERFASSUNG AUF DIESER WEBSITE? Die
          Datenverarbeitung auf dieser Website erfolgt durch den
          Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser
          Website entnehmen. WIE ERFASSEN WIR IHRE DATEN? Ihre Daten werden zum
          einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es
          sich z. B. um Daten handeln, die Sie in ein contactformular eingeben.
          Andere Daten werden automatisch oder nach Ihrer Einwilligung beim
          Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem
          technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit
          des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch,
          sobald Sie diese Website betreten. WOFÜR NUTZEN WIR IHRE DATEN? Ein
          Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der
          Website zu gewährleisten. Andere Daten können zur Analyse Ihres
          Nutzerverhaltens verwendet werden. WELCHE RECHTE HABEN SIE BEZÜGLICH
          IHRER DATEN? Sie haben jederzeit das Recht, unentgeltlich Auskunft
          über Herkunft, Empfänger und Zweck Ihrer gespeicherten
          personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die
          Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine
          Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese
          Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie
          das Recht, unter bestimmten Umständen die Einschränkung der
          Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren
          steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde
          zu. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie
          sich jederzeit unter der im Impressum angegebenen Adresse an uns
          wenden.
        </p>

        <h2>2. Allgemeine Hinweise und Pflicht­informationen</h2>

        <strong>Datenschutz</strong>

        <p>
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten
          sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und
          entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser
          Datenschutzerklärung. Wenn Sie diese Website benutzen, werden
          verschiedene personenbezogene Daten erhoben. Personenbezogene Daten
          sind Daten, mit denen Sie persönlich identifiziert werden können. Die
          vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben
          und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck
          das geschieht. Wir weisen darauf hin, dass die Datenübertragung im
          Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken
          aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch
          Dritte ist nicht möglich.
        </p>

        <strong>Hinweis zur verantwortlichen Stelle</strong>

        <p>
          Die verantwortliche Stelle für die Datenverarbeitung auf dieser
          Website ist: NWON GmbH Gutenberg Digital Hub Taunusstr. 59 - 61 55118
          Mainz VERTRETEN DURCH Felix Buchmüller E-Mail: hallo@nwon.de
          Verantwortliche Stelle ist die natürliche oder juristische Person, die
          allein oder gemeinsam mit anderen über die Zwecke und Mittel der
          Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen
          o. Ä.) entscheidet.
        </p>

        <strong>Speicherdauer</strong>

        <p>
          Soweit innerhalb dieser Datenschutzerklärung keine speziellere
          Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten
          bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie
          ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung
          zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern
          wir keinen anderen rechtlich zulässigen Gründe für die Speicherung
          Ihrer personenbezogenen Daten haben (z.B. steuer- oder
          handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall
          erfolgt die Löschung nach Fortfall dieser Gründe.
        </p>

        <strong>Hinweis zur Datenweitergabe in die USA</strong>

        <p>
          Auf unserer Website sind unter anderem Tools von Unternehmen mit Sitz
          in den USA eingebunden. Wenn diese Tools aktiv sind, können Ihre
          personenbezogenen Daten an die US-Server der jeweiligen Unternehmen
          weitergegeben werden. Wir weisen darauf hin, dass die USA kein
          sicherer Drittstaat im Sinne des EU-Datenschutzrechts sind.
          US-Unternehmen sind dazu verpflichtet, personenbezogene Daten an
          Sicherheitsbehörden herauszugeben, ohne dass Sie als Betroffener
          hiergegen gerichtlich vorgehen könnten. Es kann daher nicht
          ausgeschlossen werden, dass US-Behörden (z.B. Geheimdienste) Ihre auf
          US-Servern befindlichen Daten zu Überwachungszwecken verarbeiten,
          auswerten und dauerhaft speichern. Wir haben auf diese
          Verarbeitungstätigkeiten keinen Einfluss.
        </p>

        <strong>Widerruf Ihrer Einwilligung zur Datenverarbeitung</strong>

        <p>
          Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
          Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
          jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf
          erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
        </p>

        <strong>
          Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie
          gegen Direktwerbung (Art. 21 DSGVO)
        </strong>

        <p>
          WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER
          F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH
          AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER
          PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN
          AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE
          RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE
          DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR
          IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES
          SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE
          VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN
          ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG
          ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS.
          1 DSGVO). WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM
          DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT
          WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER
          DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS
          PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT.
          WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN
          ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET
          (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
        </p>

        <strong>Beschwerde­recht bei der zuständigen Aufsichts­behörde</strong>

        <p>
          Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein
          Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem
          Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes
          oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht
          besteht unbeschadet anderweitiger verwaltungsrechtlicher oder
          gerichtlicher Rechtsbehelfe.
        </p>

        <strong>Recht auf Daten­übertrag­barkeit</strong>

        <p>
          Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung
          oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich
          oder an einen Dritten in einem gängigen, maschinenlesbaren Format
          aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an
          einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es
          technisch machbar ist.
        </p>

        <strong>SSL- bzw. TLS-Verschlüsselung</strong>

        <p>
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
          Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder
          Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw.
          TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie
          daran, dass die Adresszeile des Browsers von „http://“ auf „https://“
          wechselt und an dem Schloss-Symbol in Ihrer Browserzeile. Wenn die
          SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie
          an uns übermitteln, nicht von Dritten mitgelesen werden.
        </p>

        <strong>Auskunft, Löschung und Berichtigung</strong>

        <p>
          Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit
          das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
          personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck
          der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder
          Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema
          personenbezogene Daten können Sie sich jederzeit unter der im
          Impressum angegebenen Adresse an uns wenden.
        </p>

        <strong>Recht auf Einschränkung der Verarbeitung</strong>

        <p>
          Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen. Hierzu können Sie sich jederzeit
          unter der im Impressum angegebenen Adresse an uns wenden. Das Recht
          auf Einschränkung der Verarbeitung besteht in folgenden Fällen: Wenn
          Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen
          Daten bestreiten, benötigen wir in der Regel Zeit, um dies zu
          überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die
          Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
          verlangen. Wenn die Verarbeitung Ihrer personenbezogenen Daten
          unrechtmäßig geschah/geschieht, können Sie statt der Löschung die
          Einschränkung der Datenverarbeitung verlangen. Wenn wir Ihre
          personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur
          Ausübung, Verteidigung oder Geltendmachung von Rechtsansprüchen
          benötigen, haben Sie das Recht, statt der Löschung die Einschränkung
          der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Ihren und
          unseren Interessen vorgenommen werden. Solange noch nicht feststeht,
          wessen Interessen überwiegen, haben Sie das Recht, die Einschränkung
          der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Wenn Sie
          die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben,
          dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer
          Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung von
          Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen
          oder juristischen Person oder aus Gründen eines wichtigen öffentlichen
          Interesses der Europäischen Union oder eines Mitgliedstaats
          verarbeitet werden.
        </p>

        <h2>3. Datenerfassung auf dieser Website</h2>

        <strong>Anfrage per E-Mail, Telefon oder Telefax</strong>

        <p>
          Wenn Sie uns per E-Mail, Telefon oder Telefax contactieren, wird Ihre
          Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten
          (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns
          gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre
          Einwilligung weiter. Die Verarbeitung dieser Daten erfolgt auf
          Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der
          Erfüllung eines Vertrags zusammenhängt oder zur Durchführung
          vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen
          beruht die Verarbeitung auf unserem berechtigten Interesse an der
          effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1
          lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)
          sofern diese abgefragt wurde. Die von Ihnen an uns per contactanfragen
          übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung
          auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der
          Zweck für die Datenspeicherung entfällt (z. B. nach abgeschlossener
          Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen –
          insbesondere gesetzliche Aufbewahrungsfristen – bleiben unberührt.
        </p>

        <h2>4. Plugins und Tools</h2>

        <strong>Vimeo</strong>

        <p>
          Diese Website nutzt Plugins des Videoportals Vimeo. Anbieter ist die
          Vimeo Inc., 555 West 18th Street, New York, New York 10011, USA. Wenn
          Sie eine unserer mit einem Vimeo-Video ausgestatteten Seiten besuchen,
          wird eine Verbindung zu den Servern von Vimeo hergestellt. Dabei wird
          dem Vimeo-Server mitgeteilt, welche unserer Seiten Sie besucht haben.
          Zudem erlangt Vimeo Ihre IP-Adresse. Dies gilt auch dann, wenn Sie
          nicht bei Vimeo eingeloggt sind oder keinen Account bei Vimeo
          besitzen. Die von Vimeo erfassten Informationen werden an den
          Vimeo-Server in den USA übermittelt. Wenn Sie in Ihrem Vimeo-Account
          eingeloggt sind, ermöglichen Sie Vimeo, Ihr Surfverhalten direkt Ihrem
          persönlichen Profil zuzuordnen. Dies können Sie verhindern, indem Sie
          sich aus Ihrem Vimeo-Account ausloggen. Zur Wiedererkennung der
          Websitebesucher verwendet Vimeo Cookies bzw. vergleichbare
          Wiedererkennungstechnologien (z.B. Device-Fingerprinting). Die Nutzung
          von Vimeo erfolgt im Interesse einer ansprechenden Darstellung unserer
          Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne des
          Art. 6 Abs. 1 lit. f DSGVO dar. Sofern eine entsprechende Einwilligung
          abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage
          von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung ist jederzeit
          widerrufbar. Die Datenübertragung in die USA wird auf die
          Standardvertragsklauseln der EU-Kommission sowie nach Aussage von
          Vimeo auf „berechtigte Geschäftsinteressen“ gestützt.
          <br />
          Details finden Sie hier:&nbsp;
          <a
            href="https://vimeo.com/privacy"
            target="_blank"
            rel="noreferrer"
            style={{ color: theme.palette.primary.main }}
          >
            https://vimeo.com/privacy
          </a>
          <br /> Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in
          der Datenschutzerklärung von Vimeo unter:&nbsp;
          <a
            href="https://vimeo.com/privacy"
            target="_blank"
            rel="noreferrer"
            style={{ color: theme.palette.primary.main }}
          >
            https://vimeo.com/privacy
          </a>
          <br /> Quelle:&nbsp;
          <a
            href="https://www.e-recht24.de/"
            target="_blank"
            rel="noreferrer"
            style={{ color: theme.palette.primary.main }}
          >
            eRecht24
          </a>
        </p>
      </>
    ),
    [Language.English]: (
      <>
        <h2>1. data protection at a glance</h2>

        <strong>General information</strong>

        <p>
          The following notices provide a simple overview of what happens to
          your personal data when you visit this website. Personal data is any
          data by which you can be personally identified. For detailed
          information on the subject of data protection, please refer to our
          privacy policy listed below this text.
        </p>

        <strong>Data collection on this website</strong>

        <p>
          WHO IS RESPONSIBLE FOR THE DATA COLLECTION ON THIS WEBSITE? The data
          processing on this website is carried out by the website operator. You
          can find his contact data in the imprint of this website. HOW DO WE
          COLLECT YOUR DATA? On the one hand, your data is collected when you
          provide it to us. This can be, for example, data that you enter in a
          contact form. Other data is collected automatically or after your
          consent when you visit the website by our IT systems. This is mainly
          technical data (e.g. internet browser, operating system or time of
          page view). The collection of this data takes place automatically as
          soon as you enter this website. WHAT DO WE USE YOUR DATA FOR? Part of
          the data is collected to ensure error-free provision of the website.
          Other data may be used to analyse your user behaviour. WHAT RIGHTS DO
          YOU HAVE REGARDING YOUR DATA? You have the right at any time to
          receive information free of charge about the origin, recipient and
          purpose of your stored personal data. You also have a right to request
          the correction or deletion of this data. If you have given your
          consent to data processing, you can revoke this consent at any time
          for the future. You also have the right to request the restriction of
          the processing of your personal data under certain circumstances.
          Furthermore, you have the right to lodge a complaint with the
          competent supervisory authority. For this as well as for further
          questions on the subject of data protection, you can contact us at any
          time at the address given in the imprint.
        </p>

        <h2>2. General notes and mandatory information</h2>

        <strong>Data protection</strong>

        <p>
          The operators of these pages take the protection of your personal data
          very seriously. We treat your personal data confidentially and in
          accordance with the statutory data protection regulations and this
          data protection declaration. When you use this website, various
          personal data are collected. Personal data is data that can be used to
          identify you personally. This privacy policy explains what data we
          collect and what we use it for. It also explains how and for what
          purpose this is done. We would like to point out that data
          transmission on the Internet (e.g. communication by e-mail) can have
          security gaps. Complete protection of data against access by third
          parties is not possible.
        </p>

        <strong>Note on the responsible body</strong>

        <p>
          The data controller for this website is: NWON GmbH Gutenberg Digital
          Hub Taunusstr. 59 - 61 55118 Mainz REPRESENTED BY Felix Buchmüller
          E-Mail: hallo@nwon.de The controller is the natural or legal person
          who alone or jointly with others determines the purposes and means of
          the processing of personal data (e.g. names, e-mail addresses, etc.).
        </p>

        <strong>Storage period</strong>

        <p>
          Unless a more specific storage period has been specified within this
          data protection declaration, your personal data will remain with us
          until the purpose for the data processing no longer applies. If you
          assert a legitimate request for deletion or revoke your consent to
          data processing, your data will be deleted unless we have other
          legally permissible reasons for storing your personal data (e.g.
          retention periods under tax or commercial law); in the latter case,
          the data will be deleted after these reasons cease to apply.
        </p>

        <strong>Note on data transfer to the USA</strong>

        <p>
          Among other things, tools from companies based in the USA are
          integrated on our website. If these tools are active, your personal
          data may be transferred to the US servers of the respective companies.
          We would like to point out that the USA is not a safe third country in
          the sense of EU data protection law. US companies are obliged to hand
          over personal data to security authorities without you as a data
          subject being able to take legal action against this. It can therefore
          not be ruled out that US authorities (e.g. intelligence services)
          process, evaluate and permanently store your data located on US
          servers for monitoring purposes. We have no influence on these
          processing activities.
        </p>

        <strong>Revocation of your consent to data processing</strong>

        <p>
          Many data processing operations are only possible with your express
          consent. You can revoke an already given consent at any time. The
          legality of the data processing carried out until the revocation
          remains unaffected by the revocation.
        </p>

        <strong>
          Right to object to the collection of data in specific cases and to
          direct marketing (Art. 21 DSGVO)
        </strong>

        <p>
          IF THE DATA PROCESSING IS CARRIED OUT ON THE BASIS OF ART. 6 ABS. 1
          LIT. E OR F DSGVO, YOU HAVE THE RIGHT TO OBJECT TO THE PROCESSING OF
          YOUR PERSONAL DATA AT ANY TIME FOR REASONS ARISING FROM YOUR
          PARTICULAR SITUATION; THIS ALSO APPLIES TO PROFILING BASED ON THESE
          PROVISIONS. THE RESPECTIVE LEGAL BASIS ON WHICH PROCESSING IS BASED
          CAN BE FOUND IN THIS DATA PROTECTION DECLARATION. IF YOU OBJECT, WE
          WILL NO LONGER PROCESS YOUR PERSONAL DATA UNLESS WE CAN DEMONSTRATE
          COMPELLING LEGITIMATE GROUNDS FOR THE PROCESSING WHICH OVERRIDE YOUR
          INTERESTS, RIGHTS AND FREEDOMS, OR THE PROCESSING SERVES THE PURPOSE
          OF ASSERTING, EXERCISING OR DEFENDING LEGAL CLAIMS (OBJECTION PURSUANT
          TO ARTICLE 21 (1) DSGVO). IF YOUR PERSONAL DATA IS PROCESSED FOR THE
          PURPOSE OF DIRECT MARKETING, YOU HAVE THE RIGHT TO OBJECT AT ANY TIME
          TO THE PROCESSING OF PERSONAL DATA CONCERNING YOU FOR THE PURPOSE OF
          SUCH MARKETING; THIS ALSO APPLIES TO PROFILING INSOFAR AS IT IS
          CONNECTED WITH SUCH DIRECT MARKETING. IF YOU OBJECT, YOUR PERSONAL
          DATA WILL SUBSEQUENTLY NO LONGER BE USED FOR THE PURPOSE OF DIRECT
          MARKETING (OBJECTION PURSUANT TO ART. 21 PARA. 2 DSGVO).
        </p>

        <strong>Right of appeal to the competent supervisory authority</strong>

        <p>
          In the event of breaches of the GDPR, data subjects shall have a right
          of appeal to a supervisory authority, in particular in the Member
          State of their habitual residence, their place of work or the place of
          the alleged breach. The right of appeal is without prejudice to any
          other administrative or judicial remedy.
        </p>

        <strong>Right to data portability</strong>

        <p>
          You have the right to have data that we process automatically on the
          basis of your consent or in fulfilment of a contract handed over to
          you or to a third party in a common, machine-readable format. If you
          request the direct transfer of the data to another controller, this
          will only be done insofar as it is technically feasible.
        </p>

        <strong>SSL or TLS encryption</strong>

        <p>
          This site uses SSL or TLS encryption for security reasons and to
          protect the transmission of confidential content, such as orders or
          enquiries that you send to us as the site operator. You can recognise
          an encrypted connection by the fact that the address line of the
          browser changes from &quot;http://&quot; to &quot;https://&quot; and
          by the lock symbol in your browser line. If SSL or TLS encryption is
          activated, the data you transmit to us cannot be read by third
          parties.
        </p>

        <strong>Information, deletion and correction</strong>

        <p>
          Within the framework of the applicable legal provisions, you have the
          right at any time to free information about your stored personal data,
          its origin and recipient and the purpose of data processing and, if
          necessary, a right to correction or deletion of this data. For this
          purpose, as well as for further questions on the subject of personal
          data, you can contact us at any time at the address given in the
          imprint.
        </p>

        <strong>Right to restrict processing</strong>

        <p>
          You have the right to request the restriction of the processing of
          your personal data. To do this, you can contact us at any time at the
          address given in the imprint. The right to restriction of processing
          exists in the following cases: If you dispute the accuracy of your
          personal data stored by us, we usually need time to verify this. For
          the duration of the review, you have the right to request the
          restriction of the processing of your personal data. If the processing
          of your personal data was/is unlawful, you may request the restriction
          of data processing instead of erasure. If we no longer need your
          personal data, but you need it to exercise, defend or enforce legal
          claims, you have the right to request restriction of the processing of
          your personal data instead of deletion. your and our interests. As
          long as it has not yet been determined whose interests prevail, you
          have the right to demand the restriction of the processing of your
          personal data. If you have restricted the processing of your personal
          data, such data may - apart from being stored - only be processed with
          your consent or for the assertion, exercise or defence of legal claims
          or for the protection of the rights of another natural or legal person
          or for reasons of important public interest of the European Union or a
          Member State.
        </p>

        <h2>3. data collection on this website</h2>

        <strong>Inquiry by e-mail, telephone or fax</strong>

        <p>
          If you contact us by e-mail, telephone or fax, your inquiry including
          all resulting personal data (name, inquiry) will be stored and
          processed by us for the purpose of processing your request. We will
          not pass on this data without your consent. The processing of this
          data is based on Art. 6 (1) lit. b DSGVO if your request is related to
          the performance of a contract or is necessary for the implementation
          of pre-contractual measures. In all other cases, the processing is
          based on our legitimate interest in the effective processing of the
          requests addressed to us (Art. 6 (1) (f) DSGVO) or on your consent
          (Art. 6 (1) (a) DSGVO) if this has been requested. The data you send
          to us via contactanfragen will remain with us until you request us to
          delete it, revoke your consent to store it or the purpose for storing
          the data no longer applies (e.g. after processing your request has
          been completed). Mandatory statutory provisions - in particular
          statutory retention periods - remain unaffected.
        </p>

        <h2>4. plugins and tools</h2>

        <strong>Vimeo</strong>

        <p>
          This website uses plugins of the video portal Vimeo. The provider is
          Vimeo Inc, 555 West 18th Street, New York, New York 10011, USA. When
          you visit one of our pages equipped with a Vimeo video, a connection
          to the Vimeo servers is established. This tells the Vimeo server which
          of our pages you have visited. In addition, Vimeo obtains your IP
          address. This also applies if you are not logged in to Vimeo or do not
          have an account with Vimeo. The information collected by Vimeo is
          transmitted to the Vimeo server in the USA. If you are logged into
          your Vimeo account, you enable Vimeo to assign your surfing behaviour
          directly to your personal profile. You can prevent this by logging out
          of your Vimeo account. Vimeo uses cookies or similar recognition
          technologies (e.g. device fingerprinting) to recognize website
          visitors. The use of Vimeo is in the interest of an appealing
          presentation of our online offers. This represents a legitimate
          interest within the meaning of Art. 6 (1) lit. f DSGVO. Insofar as a
          corresponding consent has been requested, the processing is carried
          out exclusively on the basis of Art. 6 Para. 1 lit. a DSGVO; the
          consent can be revoked at any time. Data transfer to the US is based
          on the EU Commission&apos;s standard contractual clauses and,
          according to Vimeo, on &quot;legitimate business interests&quot;.
          <br />
          Details can be found here:&nbsp;
          <a
            href="https://vimeo.com/privacy"
            target="_blank"
            rel="noreferrer"
            style={{ color: theme.palette.primary.main }}
          >
            https://vimeo.com/privacy
          </a>
          <br /> For more information on how we handle user data, please see
          Vimeo&apos;s privacy policy at:&nbsp;
          <a
            href="https://vimeo.com/privacy"
            target="_blank"
            rel="noreferrer"
            style={{ color: theme.palette.primary.main }}
          >
            https://vimeo.com/privacy
          </a>
          <br /> Source:&nbsp;
          <a
            href="https://www.e-recht24.de/"
            target="_blank"
            rel="noreferrer"
            style={{ color: theme.palette.primary.main }}
          >
            eRecht24
          </a>
        </p>
      </>
    ),
  },
};
